import { useState, useEffect } from 'react'
import { getProbationsAPI } from '../services/probation'

function UseEmpsProbations() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getProbationsAPI()
      if (!result) return

      const newData = result.result && result.result.map((d, i) => {
        return { value: d?.id, label: d?.probation }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseEmpsProbations
